import { isAlbumIndividual } from '../../../../../../../../util/album';

/**
 *Retrieves the Join Code for a given hierarchyItem
 *
 * @param {Object} hierarchyItem an album or albumFolder
 * @returns {string|*}
 */
export const getHierarchyItemJoinCode = hierarchyItem => {
  if (!hierarchyItem) {
    return undefined;
  }

  if (isAlbumIndividual(hierarchyItem)) {
    return (
      hierarchyItem.root_album_folder?.join_code ?? hierarchyItem.join_code
    );
  }

  return hierarchyItem.join_code ?? hierarchyItem.root_album_folder?.join_code;
};
